
<align class="saved-options-dropdown" small-gap>
  <dropdown
    v-show="options.length > 0"
    :align="align"
    :active="menuOpen"
    @close="menuOpen = false"
  >
    <pill sortable :empty="!activeOption" @click.native="menuOpen = !menuOpen">
      {{ activeOption ? activeOption.name : label }}
    </pill>

    <template #menu>
      <div class="dropdown-menu">
        <button
          v-for="(option, i) in options"
          :key="i"
          :class="{ active: option.active }"
          @click="select(option)"
        >
          <icon
            v-show="activeOption"
            class="success"
            :class="{ hide: !option.active }"
            name="check_circle"
          />

          <div class="option-text">
            <strong>{{ option.name }}</strong>
            <small>{{ option.description }}</small>
          </div>

          <template v-if="!hideSave">
            <icon-button icon="drive_file_rename_outline" @click.stop.prevent="edit(option)" />
            <icon-button icon="delete_outline" @click.stop.prevent="deleteOption(option)" />
          </template>
        </button>
      </div>
    </template>
  </dropdown>

  <icon-button
    v-if="allowDeselect && activeOption"
    icon="close"
    @click="select(null)"
  />

  <icon-button
    v-if="!hideSave"
    icon="save"
    :disabled="saveDisabled || !!activeOption"
    @click="$emit('save')"
  />
</align>
